import React, { useState } from "react";
import Header from "../common/Header";
import Aside from "../common/Asside";

// Utility function to format date as 'dd MMM yyyy'
const formatDate = (date) => {
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

// Utility function to get date strings in 'yyyy-MM-dd' format
const getDateString = (date) => {
  return date.toISOString().split("T")[0];
};

// Date range calculations
const calculateDateRanges = () => {
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);

  const thisWeekStart = new Date(today);
  thisWeekStart.setDate(today.getDate() - today.getDay());
  const thisWeekEnd = new Date(thisWeekStart);
  thisWeekEnd.setDate(thisWeekStart.getDate() + 6);

  const lastWeekStart = new Date(thisWeekStart);
  lastWeekStart.setDate(thisWeekStart.getDate() - 7);
  const lastWeekEnd = new Date(thisWeekStart);
  lastWeekEnd.setDate(thisWeekStart.getDate() - 1);

  const thisMonthStart = new Date(today.getFullYear(), today.getMonth(), 1);
  const thisMonthEnd = new Date(today.getFullYear(), today.getMonth() + 1, 0);

  const lastMonthStart = new Date(today.getFullYear(), today.getMonth() - 1, 1);
  const lastMonthEnd = new Date(today.getFullYear(), today.getMonth(), 0);

  return {
    today: { start: getDateString(today), end: getDateString(today) },
    yesterday: { start: getDateString(yesterday), end: getDateString(yesterday) },
    thisWeek: { start: getDateString(thisWeekStart), end: getDateString(thisWeekEnd) },
    lastWeek: { start: getDateString(lastWeekStart), end: getDateString(lastWeekEnd) },
    thisMonth: { start: getDateString(thisMonthStart), end: getDateString(thisMonthEnd) },
    lastMonth: { start: getDateString(lastMonthStart), end: getDateString(lastMonthEnd) },
  };
};

function Registration() {
  
  const [showDateFilter, setShowDateFilter] = useState(false);
  const [dateRange, setDateRange] = useState({
    start: calculateDateRanges().today.start,
    end: calculateDateRanges().today.end,
  });
  const [data, setData] = useState([]);

  const handleDateFilterToggle = () => {
    setShowDateFilter(!showDateFilter);
  };

  const handleDateFilter = (start, end) => {
    setDateRange({ start, end });
    setShowDateFilter(false);
  };

  const fetchData = async () => {
    try {
      const response = await fetch("https://esgaming.online/api/member-search", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({
          startTime: dateRange.start,
          endTime: dateRange.end,
        }),
      });
      const result = await response.json();
      setData(result);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const dateRanges = calculateDateRanges();

  return (
    <div>
      <Header />
      <div className="container-flex">
        <Aside />
        <div className="main">
          <div className="page-content">
            <div className="main-inner">
              <div className="page-content-body" style={{ display: "block" }}>
                <form action="#" id="registrationsForm" noValidate="novalidate">
                  <div className="section">
                    <div className="section-head">
                      <h2 className="title">Registration &amp; FTDs</h2>
                    </div>
                    <div className="section-body">
                      <div className="filter" id="dateFilter">
                        <button
                          type="button"
                          className="btn-primary btn-dropdown dropdown-toggle"
                          onClick={handleDateFilterToggle}
                        >
                          Date Filter
                        </button>
                        <div
                          className={`dropdown-menu filter-group ${
                            showDateFilter ? "d-block" : "d-none"
                          }`}
                        >
                          <dl className="filter-item">
                            <dd>
                              <div className="form-group">
                                <div className="btn-group">
                                  {Object.entries(dateRanges).map(([label, range]) => (
                                    <button
                                      type="button"
                                      className="btn-secondary dateFilterBtn"
                                      onClick={() =>
                                        handleDateFilter(range.start, range.end)
                                      }
                                      key={label}
                                    >
                                      {label.replace(/([A-Z])/g, " $1")}
                                    </button>
                                  ))}
                                </div>
                              </div>
                            </dd>
                          </dl>
                          <div className="filter-foot">
                            <button
                              type="button"
                              className="btn-light cancelBtn"
                              onClick={handleDateFilterToggle}
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      </div>

                      <div className="d-flex">
                        <div className="form-group form-column form-3-col">
                          <label className="label bold">From</label>
                          <input
                            type="date"
                            className="form-control valid"
                            name="startTime"
                            value={dateRange.start}
                            onChange={(e) =>
                              setDateRange((prev) => ({
                                ...prev,
                                start: e.target.value,
                              }))
                            }
                          />
                        </div>
                        <div className="form-group form-column form-3-col">
                          <label className="label bold">To</label>
                          <input
                            type="date"
                            className="form-control valid"
                            name="endTime"
                            value={dateRange.end}
                            onChange={(e) =>
                              setDateRange((prev) => ({
                                ...prev,
                                end: e.target.value,
                              }))
                            }
                          />
                        </div>

                        <div className="form-group form-column form-3-col">
                          <label className="label bold">Currency</label>
                          <select className="form-control" name="currency">
                            <option value={8}>BDT</option>
                          </select>
                        </div>
                      </div>

                      <div className="table-wrap">
                        <div id="registrationsTable_wrapper" className="dataTables_wrapper">
                          <table id="registrationsTable" className="table dataTable">
                            <thead>
                              <tr>
                                <th>#</th>
                                <th>Username</th>
                                <th>Currency</th>
                                <th>Registration Time</th>
                                <th>First Deposit Time</th>
                                <th>First Deposit Amount</th>
                                <th>Last Deposit Date</th>
                                <th>Last Deposit Amount</th>
                                <th>First Bet Time</th>
                                <th>First Bet Amount</th>
                                <th>Last Bet Time</th>
                                <th>Last Bet Amount</th>
                              </tr>
                            </thead>
                            <tbody>
                              {data.length > 0 ? (
                                data.map((member, index) => (
                                  <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>
                                    {(() => {
                                      const username = member.username || '';
                                      const visibleChars = 3;
                                      const masked = '*'.repeat(Math.max(0, username.length - visibleChars));
                                      const visible = username.slice(-visibleChars);
                                      return masked + visible;
                                    })()}
                                  </td>
                                    <td>{member.currency || "BDT"}</td>
                                    <td>{formatDate(new Date(member.registered_time))}</td>
                                    <td>{formatDate(new Date(member.first_deposit_time))}</td>
                                    <td>{member.first_deposit_amount}</td>
                                    <td>{member.last_deposit_time ? formatDate(new Date(member.last_deposit_time)) : ""}</td>
                                    <td>{member.last_deposit_amount || ""}</td>
                                    <td>{member.first_bet_time ? formatDate(new Date(member.first_bet_time)) : ""}</td>
                                    <td>{member.first_bet_amount || ""}</td>
                                    <td>{member.last_bet_time ? formatDate(new Date(member.last_bet_time)) : ""}</td>
                                    <td>{member.last_bet_amount || ""}</td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan="12" className="text-center">
                                    No data available
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>

                    <div className="section-foot">
                      <div className="btn-group float-right">
                        <button
                          type="button"
                          className="btn-addon btn-primary reload-data"
                          onClick={fetchData}
                        >
                          <span className="ic-search" />
                          <span className="text">Search</span>
                        </button>
                      </div>
                      <div className="btn-group float-right">
                        <button
                          type="button"
                          className="btn-addon btn-primary"
                          id="exportBtn"
                        >
                          <span className="ic-excel" />
                          <span className="text">Export</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Registration;
